
export default function HomeSectionDivider() {
    // Used in HomeScreen to separate sections

    // BUILD
    return (
        <div className={"bg-backgroundLight3 w-full flex justify-center px-[32px] md:px-[48px]"}>
            <div className={"w-full h-[1px] min-h-[1px] bg-greyLight3"}>
            </div>
        </div>
    );
}